"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactComponents = require("@ui-propulsion/react-components");
var _default = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var typography = theme.typography,
    palette = theme.palette;
  var pxToRem = typography.pxToRem;
  return {
    spinner: {
      animation: '$animation-rotate 1.4s linear infinite',
      width: '60%'
    },
    spinnerCircle: {
      stroke: palette.common.white,
      strokeDasharray: "".concat(pxToRem(80), ", ").concat(pxToRem(200)),
      strokeDashoffset: 0,
      animation: '$animation-pulse-grow 1.4s ease-in-out infinite'
    },
    '@keyframes animation-pulse-grow': {
      '0%': {
        strokeDasharray: "".concat(pxToRem(1), ", ").concat(pxToRem(200)),
        strokeDashoffset: 0
      },
      '50%': {
        strokeDasharray: "".concat(pxToRem(100), ", ").concat(pxToRem(200)),
        strokeDashoffset: pxToRem(-15)
      },
      '100%': {
        strokeDasharray: "".concat(pxToRem(100), ", ").concat(pxToRem(200)),
        strokeDashoffset: pxToRem(-125)
      }
    },
    '@keyframes animation-rotate': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  };
}, {
  name: 'Spinner'
});
exports.default = _default;
